export const SORTING_OPTIONS = [
  'action_count',
  'relevance_score',
  'visitor_uuid',
  'referrer.raw', // @TODO change to 'referrer' once v2 (ES) is dropped.
  'first_page_path.raw', // @TODO change to 'landing_page_url' once v2 (ES) is dropped.
  'last_page_path.raw', // @TODO change to 'exit_page_url' once v2 (ES) is dropped.
  'page_count',
  'duration',
  'device',
  'browser',
  'os',
  'created',
  'country_code',
  'frustration_score',
];

export const getSortingOptionsTranslationKey = (key: string): string =>
  key.replaceAll(/_|\./g, '-');

// @TODO remove once v2 (ES) is dropped.
export const SORTING_OPTIONS_V2_TO_V3: Record<string, string> = {
  'referrer.raw': 'referrer',
  'first_page_path.raw': 'landing_page_url',
  'last_page_path.raw': 'exit_page_url',
};
